//------------------------------------------------------------------------------
// 検索パネル
//------------------------------------------------------------------------------
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import NegativeButton from '@/components/atoms/Buttons/NegativeButton';
import { PositiveButton2 } from '@/components/atoms/Buttons/PositiveButton';

/**
 * 検索パネル
 */
function SearchPanel({
  children,
  expanded,
  handleClear,
  handleSearch,
  handleExpand,
}) {
  //
  // 描画
  //
  return (
    <Accordion
      expanded={expanded}
      disableGutters
    >
      {/* 検索タイトル */}
      <AccordionSummary
        aria-controls="search-panel"
        expandIcon={<ExpandMoreIcon />}
        onClick={handleExpand}
      >
        <Typography>検索条件</Typography>
      </AccordionSummary>

      {/* 検索条件 */}
      <AccordionDetails
        id="search-panel-details"
        sx={{ pt: 0 }}
      >
        {children}

        {/* 検索ボタンエリア */}              
        <Grid container
          justifyContent="flex-end"
          alignItems="flex-start"
          direction="row"
          spacing={1}
          sx={{ mt: 1 }}
        >
          {/* クリアボタン */}
          <Grid item key="button-clear">
            <NegativeButton
              variant="contained"
              startIcon={<RotateLeftIcon />}
              size="large"
              onClick={handleClear}
            >
              クリア
            </NegativeButton>
          </Grid>

          {/* 検索ボタン */}
          <Grid item key="button-search">
            <PositiveButton2
              variant="contained"
              startIcon={<SearchIcon />}
              size="large"
              onClick={handleSearch}
            >
              検索
            </PositiveButton2>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}

// プロパティ
SearchPanel.propTypes = {

  // 検索条件入力項目
  children: PropTypes.node.isRequired,

  // パネル開閉状態
  expanded: PropTypes.bool,

  // イベントハンドラ
  handleClear: PropTypes.func.isRequired,     // クリア
  handleSearch: PropTypes.func.isRequired,    // 検索
  handleExpand: PropTypes.func.isRequired,    // 開閉
};

// エクスポート
export default SearchPanel;
